export const paginationComponentApiEditDisplay = [
    {
        key: 'key',
        ignore: false,
        weight: 1,
    },
    {
        type: 'checkbox',
        input: false,
        label: 'Is start page 0 (zero)',
        key: 'isStartPageZero',
        defaultValue: true,
        weight: 2,
    },
    {
        key: 'tags',
        ignore: true,
    },
    {
        key: 'properties',
        ignore: true,
    }
];